import {BaseMapData} from './BaseMapData'
import * as Map from './MapDataList'
import {MapSettingEnum, ModeSettingEnum} from '../GameEnums'
import {ArrayUtils} from '@colonist/utils'
import {TranslationObject} from '@colonist/i18n'

export class MapDataController {
    static mapDataList: BaseMapData[] = [
        new Map.MapDataClassic4P(), new Map.MapDataTutorialClassic4P(), new Map.MapDataCampaignLevel1(), new Map.MapDataCampaignLevel2(), new Map.MapDataClassic4PRandom(), new Map.MapDataClassic56P(), new Map.MapDataClassic78P(),

        new Map.MapDataSS1HeadingForNewShores3P(), new Map.MapDataSS2FourIslands3P(), new Map.MapDataSS3FogIslands3P(), new Map.MapDataSS4ThroughTheDesert3P(),
        new Map.MapDataSS1HeadingForNewShores4P(), new Map.MapDataSS2FourIslands4P(), new Map.MapDataSS3FogIslands4P(), new Map.MapDataSS4ThroughTheDesert4P(),

        new Map.MapDataTutorialSS1HeadingForNewShores4P(), new Map.MapDataTutorialSS2FourIslands4P(), new Map.MapDataTutorialSS3FogIslands4P(), new Map.MapDataTutorialSS4ThroughTheDesert4P(),

        new Map.MapDataSS1HeadingForNewShores56P(), new Map.MapDataSS2SixIslands56P(), new Map.MapDataSS3FogIslands56P(), new Map.MapDataSS4ThroughTheDesert56P(),

        new Map.MapDataEarth(), new Map.MapDataEarthSeafarers(), new Map.MapDataUSA(), new Map.MapDataUK(), new Map.MapDataUKSeafarers(), new Map.MapDataDiamond(), new Map.MapDataGear(), new Map.MapDataLakes(), new Map.MapDataPond(), new Map.MapDataTwirl(),
        new Map.MapDataShuffleBoard(), new Map.MapDataBlackForest(),
        new Map.MapDataVolcano(),
        new Map.MapDataCircle(),
        new Map.MapDataKite(),
        new Map.MapDataDuel(),
        new Map.MapDataMiniBase(),
        new Map.MapDataKingOfTheHill(),
        new Map.MapDataMountainOfRiches(),
        new Map.MapDataDoggo(),
        new Map.MapDataTradeIslands(),
        new Map.MapDataTradeIslandSeafarers(),
        new Map.MapDataVietnam(),
        new Map.MapDataTurningTidesClassic(),
        new Map.MapDataTurningTidesSeafarers(),
        new Map.MapDataTwoIsles(),
        new Map.MapDataJellyFish(),
        new Map.MapDataRomania(),
        new Map.MapDataMonopoly(),
        new Map.MapDataGoldRush(),
        new Map.MapDataIstanbul(),
        new Map.MapDataIstanbulSeafareres(),
        new Map.MapDataEurope(),
        new Map.MapDataEuropeSeafarers(),
        new Map.MapDataStripes(),
        new Map.MapDataMonopolyIslands(),
        new Map.MapDataMonopolyIslandsSeafarers(),
    ]

    static getMapDataForMap(mapSetting: MapSettingEnum): BaseMapData | undefined {
        for(const map of MapDataController.mapDataList) {
            if(map.mapEnum == mapSetting) return map.getNewInstanceOfData()
        }
        return undefined
    }

    static getMapName(mapSetting: MapSettingEnum): TranslationObject {
        const mapText = this.getMapDataForMap(mapSetting)?.name
        const defaultMapText: TranslationObject = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {value: MapSettingEnum[mapSetting]},
        }
        return mapText ?? defaultMapText
    }

    static getMapDataCompatibleWithGameMode(modeSetting: ModeSettingEnum): BaseMapData[] {
        const compatibleMaps: BaseMapData[] = []
        for(const map of MapDataController.mapDataList) {
            if(!ArrayUtils.elementInArray(map.compatibleGameModes, modeSetting)) continue
            compatibleMaps.push(map)
        }
        return compatibleMaps
    }

    static getMapDataCompatibleWithGameModes(modeSettings: ModeSettingEnum[]): BaseMapData[] {
        const compatibleMaps: BaseMapData[] = []
        for(const map of MapDataController.mapDataList) {
            for(const compatibleModes of map.compatibleGameModes) {
                if(!ArrayUtils.elementInArray(modeSettings, compatibleModes)) continue

                compatibleMaps.push(map)
                break
            }
        }
        return compatibleMaps
    }

    static isMapActive(mapSetting: MapSettingEnum): boolean {
        for(const map of MapDataController.mapDataList) {
            if(map.mapEnum != mapSetting) continue
            return map.isActive
        }
        return false
    }
}
